import { render, staticRenderFns } from "./id.vue?vue&type=template&id=d20349ea&scoped=true"
import script from "./id.vue?vue&type=script&lang=js"
export * from "./id.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20349ea",
  null
  
)

export default component.exports